import React from "react";

import {rpAppLink} from "@pg-mono/rp-routes";

import {OfferLocationLinksItem} from "./OfferListLocationLinksItem";

export interface IProps {
    regions: IRecommendedRegion[];
}

export interface IRecommendedRegion {
    id: number;
    name: string;
    slug: string;
}

export const RegionsVendorsLinks = React.memo(({regions}: IProps) => {
    return (
        <>
            {regions.map(({slug, name, id}) => {
                const link = rpAppLink.vendor.listFriendly({friendlySlug: slug});
                const linkText = `Deweloperzy ${name}`;

                return <OfferLocationLinksItem disableSelfLinking linkText={linkText} url={link} key={id} />;
            })}
        </>
    );
});
